import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import './VenueDetail.css';

function Hall() {
  const [space, setSpace] = useState(null);

  useEffect(() => {
    client
      .fetch('*[_type == "venue"][0]{ spaces[slug == "hall"][0] }')
      .then(data => {
        if (data && data.spaces) setSpace(data.spaces);
      });
  }, []);

  const images = (space && space.images) || [];
  const validImages = images.filter(img => img && img.asset);

  return (
    <div className="venue-detail-page">
      <SEO
        title="1F 홀 | Hall"
        description="가든포에트 1F 홀 - 자연광이 쏟아지는 넓은 홀. 피로연, 리셉션, 프라이빗 다이닝에 완벽한 공간."
        path="/venue/hall"
      />
      <section className="detail-hero">
        <div className="container">
          <div className="detail-hero-content fade-in">
            <h1>HALL</h1>
            <p className="capacity-tag">수용 인원: 최대 80명</p>
          </div>
        </div>
      </section>

      <section className="detail-description">
        <div className="container">
          <div className="space-notice fade-in">
            <span className="notice-tag">📷 시즌 프리뷰</span>
          </div>
          <div className="description-content fade-in">
            <p>
              하얀 벽돌벽과 우드, 플랜테리어가 어우러진<br />
              빈티지한 공간입니다.<br />
              큰 창 너머로 정원의 자작나무가 보이고,<br />
              마치 유럽 시골 마을의 작은 집에<br />
              초대받은 것 같은 느낌이 듭니다.
            </p>
            <p>
              비가 오거나 추운 겨울에도<br />
              걱정 없이 식사를 할 수 있는 공간이 필요하다면,<br />
              1층 홀에서 편안하게 시간을 보내세요.<br />
              정원에서 예식을 마친 후 이곳으로 들어와<br />
              따뜻한 식사를 시작할 수 있습니다.
            </p>
            <p>
              오후 햇살이 벽돌벽에 부드럽게 스며들고,<br />
              저녁이 되면 따뜻한 조명 아래<br />
              긴 테이블에 사람들이 둘러앉습니다.<br />
              주방에서는 요리하는 소리가 들리고,<br />
              와인잔이 부딪히는 소리, 웃음이 섞입니다.
            </p>
            <p>
              대형 키친과 케이터링 바가 마련되어 있어서,<br />
              갓 준비된 따뜻한 요리가 나옵니다.<br />
              갓 구운 빵 냄새, 허브의 향이 공간을 채우고,<br />
              정성스럽게 플레이팅된 접시들이 테이블 위에 놓입니다.
            </p>
            <p>
              화이트 톤의 벽돌벽과 우드 가구들,<br />
              곳곳에 놓인 식물들이 그 자체로 포토존이 됩니다.<br />
              실내 예식도 가능하며,<br />
              날씨에 구애받지 않고 계획했던 대로 진행할 수 있어요.
            </p>
            <p className="closing">
              최대 80명까지 수용 가능합니다.<br />
              창밖으로 자작나무가 바람에 흔들리는 모습을 보며,<br />
              실내에서는 따뜻한 분위기 속에서<br />
              당신의 특별한 날을 함께 축하합니다.<br />
              야외의 낭만과 실내의 포근함이 만나는 곳입니다.
            </p>
          </div>
        </div>
      </section>

      {validImages.length > 0 && (
        <section className="detail-gallery">
          <div className="container-wide">
            <div className="gallery-grid fade-in">
              {validImages.map(function(image, i) {
                return (
                  <div key={i} className="gallery-item">
                    <img 
                      src={urlFor(image).width(800).url()} 
                      alt={`1층 홀 ${i + 1}`}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Hall;
